import React from "react"

import { Title } from "../styles"
import { Wrapper, Details, Item, ItemTitle, ItemText, EmptyItem } from "./styles"

const RecipeOverview = ({ prepTimeMinutes, cookTimeMinutes, servings, yieldType = "people" }) => {
  const items = [
    { title: "Prep Time", text: `${prepTimeMinutes} minutes` },
    { title: "Cook Time", text: `${cookTimeMinutes} minutes` },
    { title: "Servings", text: `${servings} ${yieldType}` },
  ]

  return (
    <Wrapper>
      <Title>Recipe Overview</Title>
      <Details>
        {items.map(({ title, text }) => (
          <Item key={title}>
            <ItemTitle>{title}</ItemTitle>
            <ItemText>{text}</ItemText>
          </Item>
        ))}
        <EmptyItem />
      </Details>
    </Wrapper>
  )
}

export default RecipeOverview
